import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import type { PublishItem } from 'reactApp/modules/modifying/modifying.types';
import { getItemById, getStorageItemById } from 'reactApp/modules/storage/storage.selectors';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';

export function useItemById(id: string, itemStorage?: EStorageType) {
    const getItem = useCallback(
        (state) => (itemStorage ? getStorageItemById(state, itemStorage, id) : getItemById(state, id)),
        [id, itemStorage]
    );
    return useSelector(getItem) as PublishItem;
}
